// extracted by mini-css-extract-plugin
module.exports = {"LoadMore":"LoadMoreButton_LoadMore__Dkfw5","LoadMore-icon":"LoadMoreButton_LoadMore-icon__Xao1C"};